import EntityType from '@/shared/enums/EntityType';
import ScopeType from '@/shared/enums/ScopeType';
import ViewMode from '@/shared/enums/ViewMode';
import defaultScope from './defaultScope';

const getViewMode = (viewMode) => {
  return ViewMode[viewMode] ?? ViewMode.DIAGRAM;
};

const getScope = (scope, viewMode) => {
  return ScopeType[scope] ?? defaultScope(viewMode);
};

export default function getSearchParams(params) {
  const view = getViewMode(params?.get('view'));
  const scope = getScope(params.get('scope'), view);

  let scopeEntity;
  let id;

  if (params.get(EntityType.ACTIVITY)) {
    scopeEntity = EntityType.ACTIVITY;
    id = params.get(EntityType.ACTIVITY);
  }

  if (params.get(EntityType.GROUP)) {
    scopeEntity = EntityType.GROUP;
    id = params.get(EntityType.GROUP);
  }

  if (params.get(EntityType.ROLE)) {
    scopeEntity = EntityType.ROLE;
    id = params.get(EntityType.ROLE);
  }

  if (params.get(EntityType.TAG)) {
    scopeEntity = EntityType.TAG;
    id = params.get(EntityType.TAG);
  }

  if (!scopeEntity) {
    scopeEntity = EntityType.GROUP;
  }

  const settings = params.get('settings');

  return {
    view,
    scope,
    scopeEntity,
    id,
    settings,
  };
}
